
import Vue from 'vue';
import EuButton from '../Button/Button.vue';
import EuCard from '../Card/Card.vue';
import GreenTick from '../../../Icons/GreenTick.vue';
export default Vue.extend<any, any, any, any>({
  name: 'GeneralTopContent',
  data() {
    return {
      expand: false
    };
  },
  components: {
    EuButton,
    EuCard,
    GreenTick
  },
  props: {
    /**
     * Set id
     */
    id: {
      type: [Number, String],
      default: ''
    },
    /**
     * Information shown on card
     */
    cardInformation: {
      type: Object,
      required: true
    },
    /**
     * Set maximum list shown before clicking view more
     */
    maxList: {
      type: Number,
      default: 1
    },
    /**
     * Set bullet icon on list
     */
    bulletIcon: {
      type: [String, Object],
      default: () => GreenTick
    },
    /**
     * Force the View Label
     */
    forceViewLabel: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    computedList() {
      if (this.expand) {
        return this.cardInformation.desc.length;
      }
      return this.maxList;
    },
    computedViewLabel() {
      if (this.expand) return this.cardInformation.viewLessLabel;
      return this.cardInformation.viewMoreLabel;
    },
    hasViewLabel() {
      if (this.forceViewLabel) {
        return true;
      }
      return this.cardInformation.desc.length > this.maxList;
    },
    hasCustomList() {
      return this.$scopedSlots.customlist ? this.$scopedSlots.customlist() : false;
    }
  },
  methods: {
    handleViewMore(e: any) {
      /**
       * Method to click on view more
       * @event view
       * @type {function}
       */
      this.$emit('view', e);
      this.expand = !this.expand;
    }
  }
});
